// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoIcon_info__2Pt0u"};